module.exports = __webpack_public_path__ + "static/media/eventshead.9ac05973.jpg";